import { Button, Container, Stack } from "@mui/material";
import { useNavigate } from "react-router";
import { LogosHeader } from "../../components/LogosHeader";
import { Logger } from '../../utils/Logger';

export const HomePage = () => {
    Logger.debug('COMPONENT', "HomePage rendered");
    const navigate = useNavigate();
    const goToBailleurs = () => {
        Logger.debug('COMPONENT', "HomePage navigating to /bailleurs");
        navigate("/bailleurs");
    }
    const goToNouveauLogement = () => {
        navigate("/new");
    }
    return (
        <>
            <LogosHeader sx={{p: 2}} />
            <Container sx={{p: "1 0", position: "fixed", bottom: 0, top: "auto", left: 0, right: 0, margin: "0 auto"}} maxWidth="md">
                <Stack direction={"row"} spacing={1} padding={1}>
                    <Button
                        onClick={() => goToBailleurs()}
                        fullWidth
                        variant="contained">
                        Liste des logements
                    </Button>
                    <Button
                        onClick={() => goToNouveauLogement()}
                        fullWidth
                        variant="contained">
                        Nouveau logement
                    </Button>
                </Stack>
            </Container>
        </>
    );
}
